import React from "react";
import Select from "react-select";
import DropDownStyles from "./dropdownStyles";
import { useWeightUnits, normalizeUnitsData } from "../../hooks/queries/useWeightUnits";

const WeightUnitDropDownSelection = ({ onChange, selectedValue }) => {
  const { data } = useWeightUnits({ search: "" });
  const weightUnit = normalizeUnitsData(data);

  const WeightUnitOptions = weightUnit.map((unit) => ({
    value: Number(unit.id),
    label: unit.Name,
  }));

  return (
    <Select
      value={
        WeightUnitOptions.find((option) => option.value === Number(selectedValue)) ||
        null
      }
      onChange={onChange}
      options={WeightUnitOptions}
      styles={DropDownStyles}
      placeholder="Select Weight Unit"
      isClearable={true}
    />
  );
};

export default WeightUnitDropDownSelection;
